module.exports = __webpack_public_path__ + "img/53.5.COD.e416fc42.png";